export const fiscalYearStarts = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11] as const;
export type FiscalYearStarts = (typeof fiscalYearStarts)[number];

export const fiscalYearFormats = ['FY Q', 'Q FY', 'YYYY Q', 'Q YYYY'] as const;
export type FiscalYearFormats = (typeof fiscalYearFormats)[number];

export const weekStarts = [0, 1] as const;
export type WeekStarts = (typeof weekStarts)[number];

export const visibleRows = [1, 2, 3] as const;
export type VisibleRows = (typeof visibleRows)[number];

export const resolution = ['day', 'week', 'month', 'quarter', 'year'] as const;
export type Resolution = (typeof resolution)[number];
